module.exports = __webpack_public_path__ + "static/media/IMG_0036.bb38c1d4.JPG";